module.exports = " <div class=tweet _v-d46e51a4=\"\"> <div class=col-sm-4 v-bind:class=\"['twbox', twstate, twposition]\" _v-d46e51a4=\"\"> <span class=\"badge {{twstate}}\" _v-d46e51a4=\"\">{{twstate}}</span> <div id=twBox _v-d46e51a4=\"\"></div> <h5 v-if=\"twlinks > 0\" _v-d46e51a4=\"\">quotes …</h5> <div id=quoteBox _v-d46e51a4=\"\"></div> </div> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-d46e51a4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tweet.vue
 ** module id = 59
 ** module chunks = 2
 **/